import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { Subject } from 'rxjs';
import { environment } from './../../environments/environment';
import { AccountService } from './account.service';

@Injectable({
  providedIn: 'root'
})
export class AlertaTempoSessaoService {

  sessaoExpirada = false
  baseUrl = environment.baseUrl
  idleDetector!: Subject<boolean>;
  setInterval: any
  redirecionar!: Subject<boolean>;
  fimDaSessao!: Subject<boolean>;
  sessaoEncerrada!: Subject<boolean>;
  premocenter = environment.baseUrlPremocenter

  constructor(
    private http: HttpClient,
    private router: Router,
    private accountService: AccountService
  ) {
    this.fimDaSessao = new Subject();
    this.sessaoEncerrada = new Subject();
  }


  watcher() {
    return this.idleDetector.asObservable();
  }

  alertaFimSessao() {
    return this.fimDaSessao.asObservable();
  }
  alertaSessaoEncerrada() {
    return this.sessaoEncerrada.asObservable();
  }

  redirecionarPremocenter() {
    return this.redirecionar.asObservable();
  }

  alertaSessaoService() {
    clearInterval(this.setInterval)
    this.setInterval = setInterval(() => {
      const dataExpiraToken = this.accountService.obterExpiracaoTokenCookie();

      if (!dataExpiraToken) {
        // Fallback para comportamento legado se o cookie não estiver presente
        const token = localStorage.getItem('token');
        if (!token) return;

        try {
          const decoded: any = jwt_decode.default(token);
          const fbDataExpira = new Date(0);
          fbDataExpira.setUTCSeconds(decoded.exp);
          this.processarAlertas(fbDataExpira);
        } catch (e) {
          console.error('Erro ao decodificar token no fallback:', e);
        }
      } else {
        this.processarAlertas(dataExpiraToken);
      }
    }, 180 * 1000)
  }

  private processarAlertas(dataExpiraToken: Date) {
    if (!dataExpiraToken) return;

    var hours = dataExpiraToken.getHours();
    var minutes = "0" + dataExpiraToken.getMinutes();
    var seconds = "0" + dataExpiraToken.getSeconds();
    var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    localStorage.setItem('expira_token', formattedTime)
    var dataAtual = new Date(); //data corrente
    var dataExibirMensagem = dataExpiraToken.valueOf() - (300 * 1000) // data que começa exibir mensagem do final da sessao

    if (dataAtual.valueOf() >= dataExibirMensagem && dataAtual.valueOf() <= dataExpiraToken.valueOf()) {
      this.sessaoExpirada = true;
      this.fimDaSessao.next(this.sessaoExpirada)
    }
    else if (dataAtual.valueOf() >= dataExpiraToken.valueOf()) {
      window.location.href = `${this.premocenter}`
    }
    else {
      this.sessaoExpirada = false;
      this.fimDaSessao.next(this.sessaoExpirada)
      this.sessaoEncerrada.next(this.sessaoExpirada)
    }
  }

  renovarToken(token: any) {
    var url = `${this.baseUrl}refresh`
    return this.http.post(url, token)
  }

  cancelar() {
    clearInterval(this.setInterval)
  }


}
